import { render, staticRenderFns } from "./bottomBasin.vue?vue&type=template&id=51e6f555&"
import script from "./bottomBasin.vue?vue&type=script&lang=js&"
export * from "./bottomBasin.vue?vue&type=script&lang=js&"
import style0 from "./bottomBasin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports